// extracted by mini-css-extract-plugin
export default {"heading":"dw-z","corrected":"ew-z","redirectVerbiageContainer":"fw-z","redirectVerbiageText":"gw-z"};